import {
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import React from "react";
import { useFormContext } from "react-hook-form";

const ReagentsForm = () => {
  const { watch } = useFormContext();
  const numberLotValue = watch("number_lot");
  const reactiveNumberValue = watch("reactive_number");

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"name"}
          name={"name"}
          label={"Nombre"}
          type="text"
          fullWidth
          validation={{ required: `El nombre es requerido` }}
        />
        <MTextField
          key={"number_lot"}
          name={"number_lot"}
          label={"Numero de lote"}
          type="text"
          fullWidth
          validation={{
            required:
              !numberLotValue && !reactiveNumberValue
                ? `El número de lote es requerido`
                : false,
          }}
        />
        <MTextField
          key={"reactive_number"}
          name={"reactive_number"}
          label={"Numero reactivo"}
          type="text"
          fullWidth
          validation={{
            required:
              !numberLotValue && !reactiveNumberValue
                ? `El Número de reactivo es requerido`
                : false,
          }}
        />
        <MTextField
          key={"concentration"}
          name={"concentration"}
          label={"Concentraciòn"}
          type="text"
          fullWidth
        />
        <MDatePicker
          key={"start_date_use"}
          name={"start_date_use"}
          pickerType="date"
          label={"Fecha inicio"}
        />
        <MDatePicker
          key={"end_date_use"}
          name={"end_date_use"}
          pickerType="date"
          label={"Fecha fin"}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default ReagentsForm;
